import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/toast";
import { ToastProvider } from "./hooks/use-toast";
import Dashboard from "./features/Dashboard/Dashboard";
import Claims from "./features/Claims/Claims";
import ClaimView from "./features/Claims/ClaimView";
import Customers from "./features/Employees/Employees";
import ProtectionPlans from "./features/ProtectionPlans/ProtectionPlans";
import ProtectionPlanTemplates from "./features/ProtectionPlanTemplates/ProtectionPlanTemplates";
import CreateProtectionPlanTemplate from "./features/ProtectionPlanTemplates/CreateProtectionPlanTemplate";
import CreateTicket from "./features/CreateTicket/CreateTicket";
import CreateTicketFromMail from "./features/CreateTicket/CreateTicketFromMail";
import AiSettings from "./features/AISettings/AiSettings";
import HomePage from "./features/HomePage/HomePage";
import Products from "./features/ProductsTreatments/Products";
import AIChat from "./components/VibrantSolComponents/AIChat";
import Checkout from "./features/CheckOut/Checkout";
import OrderPage from "./features/Orders/OrderPage";
import ContactUs from "./features/ContactUs/ContactUs";
import AboutUs from "./features/AboutUs/AboutUs";
import Faq from "./features/Faqs/Faq";
import OurExperts from "./features/OurExperts/OurExperts";
import Blogs from "./features/Blogs/Blogs";
import AdminOrderList from "./features/AdminOrderList/AdminOrderList";
import OrderDetails from "./features/AdminOrderList/OrderDetails";
import AdminProducts from "./features/AdminProducts/AdminProducts";
import Employees from "./features/Employees/Employees";
import AddProduct from "./features/AdminProducts/AddProduct";
import Inventory from "./features/Inventory/Inventory";
import AddEmployee from "./features/Employees/AddEmployee";
import ProductDetails from "./features/AdminProducts/ProductDetails";
import ProfileSettings from "./features/ProfileSettings/ProfileSettings";
import RoleManagement from "./features/RoleManagement/RoleManagement";
import BlogDetails from "./features/Blogs/BlogDetails";
import SingleProductDetails from "./features/ProductsTreatments/SingleProductDetails";
import ForgotPassword from "./features/Login/ForgotPassword";
const ProtectedRoutes = lazy(() => import("./routes/ProtectedRoutes"));
const SetPassword = lazy(() => import("./features/Login/SetPassword"));

function App() {
  return (
    <ToastProvider>
      <BrowserRouter>
        <Suspense fallback={<div className="p-4 text-center">Loading...</div>}>
          <Routes>
            {/* Protected routes */}
            <Route path="/" element={<ProtectedRoutes />}>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="adminorders" element={<AdminOrderList />} />
              <Route
                path="adminorders/orderdetails"
                element={<OrderDetails />}
              />
              <Route path="adminproducts" element={<AdminProducts />} />
              <Route path="adminproducts/addproduct" element={<AddProduct />} />
              <Route path="inventory" element={<Inventory />} />
              <Route path="claims" element={<Claims />} />
              <Route path="claimview/:claimId" element={<ClaimView />} />
              <Route path="employees" element={<Employees />} />
              <Route path="employees/addemployee" element={<AddEmployee />} />
              <Route
                path="adminproducts/productdetails"
                element={<ProductDetails />}
              />
              <Route path="profilesettings" element={<ProfileSettings />} />
              <Route path="rolemanagement" element={<RoleManagement />} />
              <Route path="protection-plans" element={<ProtectionPlans />} />
              <Route
                path="protection-plan-templates"
                element={<ProtectionPlanTemplates />}
              />
              <Route
                path="create-protection-plan"
                element={<CreateProtectionPlanTemplate />}
              />
              <Route path="ai-settings" element={<AiSettings />} />
            </Route>

            {/* Ticket creation & public routes */}
            <Route path="/createticket" element={<CreateTicket />} />
            <Route
              path="/submitticket/:claimId"
              element={<CreateTicketFromMail />}
            />
            <Route path="/createticket/:planId" element={<CreateTicket />} />
            <Route path="/homepage" element={<HomePage />} />
            <Route path="/forgotPassword" element={<ForgotPassword />} />
            <Route path="/setpassword/:token" element={<SetPassword />} />
            <Route path="/products" element={<Products />} />
            <Route
              path="/singleproductdetails"
              element={<SingleProductDetails />}
            />
            <Route path="/ourexperts" element={<OurExperts />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/blogdetails" element={<BlogDetails />} />
            <Route path="/aichat" element={<AIChat />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/myorders" element={<OrderPage />} />
            <Route path="/contactus" element={<ContactUs />} />
            <Route path="/aboutus" element={<AboutUs />} />
            <Route path="/faqs" element={<Faq />} />
          </Routes>
        </Suspense>
        <Toaster />
      </BrowserRouter>
    </ToastProvider>
  );
}

export default App;
